<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer class="sidenav" mode="over" [opened]="false">
        
        <mat-toolbar class="toolbar-mobile">{{'reservemain.title'|traduccion}}</mat-toolbar>
        <mat-nav-list>

            <mat-list-item *appShowForSigned="'not'" (click)="drawer.close()">
                <mat-icon matListIcon>home</mat-icon>
                <a matLine [routerLink]="['signin']">{{'signin'|traduccion}}</a>
            </mat-list-item>

            <mat-list-item *appShowForSigned>
                <mat-icon matListIcon>account_circle</mat-icon>
                <button mat-button [matMenuTriggerFor]="profileMenu">{{'reserves.profile'|traduccion}}</button>
                <mat-menu #profileMenu="matMenu">
                    <button mat-menu-item [routerLink]="['reserves']" (click)="drawer.close()">
                        <mat-icon>confirmation_number</mat-icon>
                        {{'reserves.myReserves'|traduccion}}
                    </button>
                    <button *appShowForRoles="['ROLE_ADMIN']" mat-menu-item [routerLink]="['my-wallet']" (click)="drawer.close()">
                        <mat-icon>wallet</mat-icon>
                            {{'reserves.myWallet'|traduccion}}
                    </button>
                    <button *appShowForRoles="['ROLE_COMMISSION_AGENT']" mat-menu-item [routerLink]="['my-commissions']" (click)="drawer.close()">
                        <mat-icon>payments</mat-icon>
                        {{'reserves.myCommissions'|traduccion}}
                    </button>
                    <button mat-menu-item (click)="logout();drawer.close();">
                        <mat-icon>logout</mat-icon>
                        {{'logout'|traduccion}}
                    </button>
                </mat-menu>
            </mat-list-item>
            
            
            

        </mat-nav-list>
    </mat-sidenav>

    
    <mat-sidenav-content>
        <mat-toolbar color="primary" class="toolbar">
            <button type="button" mat-icon-button (click)="drawer.toggle()" class="menu-button">
                <mat-icon>menu</mat-icon>
            </button>

            <a class="navbar-brand" [href]="getUrlBase()">
                <!--<img alt="mylocker.site" src="/assets/img/mylockersite1.png" height="50px">-->

                <img height="50px" alt="{{configService.settings.name}}" [src]="configService.settings.logo.imageMedium" [srcset]="
                            configService.settings.logo.imageSmall + ' 200w,
                        ' + configService.settings.logo.imageMedium + ' 400w,
                        ' + configService.settings.logo.imageLarge + ' 800w'
                    "
                    />

            </a>            
            <a class="title-page" [routerLink]="['reserve', getPathHome(), 'locker-location']">
                {{'reservemain.title'|traduccion}}</a>
            <span *ngIf="isReserve()" class="step">{{step}}</span>

            <span class="spacer"></span>

            <!-- Menú de escritorio -->
            <nav class="nav-links">
                
                <div class="hide-in-mobile">
                    <a *appShowForSigned="'not'" mat-button [routerLink]="['signin']">{{'signin'|traduccion}}</a>
                    <button *appShowForSigned mat-button [matMenuTriggerFor]="profileMenu">
                        <mat-icon>account_circle</mat-icon>
                        {{'reserves.profile'|traduccion}}
                    </button>
                    <mat-menu #profileMenu="matMenu">
                        <button mat-menu-item [routerLink]="['reserves']">
                            <mat-icon>confirmation_number</mat-icon>
                            {{'reserves.myReserves'|traduccion}}
                        </button>
                        <button *appShowForRoles="['ROLE_ADMIN']" mat-menu-item [routerLink]="['my-wallet']">
                            <mat-icon>wallet</mat-icon>
                            {{'reserves.myWallet'|traduccion}}
                        </button>
                        <button *appShowForRoles="['ROLE_COMMISSION_AGENT']" mat-menu-item [routerLink]="['my-commissions']">
                            <mat-icon>payments</mat-icon>
                            {{'reserves.myCommissions'|traduccion}}
                        </button>
                        <button mat-menu-item (click)="logout()">
                            <mat-icon>logout</mat-icon>
                            {{'logout'|traduccion}}
                        </button>
                    </mat-menu>
                </div>
                
                <button mat-button [matMenuTriggerFor]="langMenu">
                    <img src="/assets/webp/{{langSel.name}}.webp" width="24" alt="{{langSel.name}}" />
                </button>
                <mat-menu #langMenu="matMenu">
                    <div *ngFor="let lang of langs">
                        <button mat-menu-item  *ngIf="lang.name!=langSel.name" (click)="selectLang(lang)">
                            <img src="/assets/webp/{{lang.name}}.webp" width="24" alt="{{lang.name}}" /> {{lang.name}}
                        </button>
                    </div>
                </mat-menu>
                

            </nav>
        </mat-toolbar>
        
    </mat-sidenav-content>
</mat-sidenav-container>